export const COMMENT = "comm" as const;
export const RULESET = "rule" as const;
export const DECLARATION = "decl" as const;

// export const PAGE = "@page" as const;
// export const MEDIA = "@media" as const;
export const IMPORT = "@import" as const;
// export const CHARSET = "@charset" as const;
// export const VIEWPORT = "@viewport" as const;
// export const SUPPORTS = "@supports" as const;
// export const DOCUMENT = "@document" as const;
export const NAMESPACE = "@namespace" as const;
export const KEYFRAMES = "@keyframes" as const;
// export const FONT_FACE = "@font-face" as const;
// export const COUNTER_STYLE = "@counter-style" as const;
// export const FONT_FEATURE_VALUES = "@font-feature-values" as const;
export const LAYER = "@layer" as const;
// export const SCOPE = "@scope" as const;

export const LEFT_CURLY_BRACKET = "{" as const;
export const RIGHT_CURLY_BRACKET = "}" as const;
export const LEFT_PARENTHESIS = "(" as const;
export const RIGHT_PARENTHESIS = ")" as const;
export const LEFT_SQUARE_BRACKET = "[" as const;
export const RIGHT_SQUARE_BRACKET = "]" as const;
export const COLON = ":" as const;
export const SEMICOLON = ";" as const;
export const DOUBLE_QUOTE = '"' as const;
export const SINGLE_QUOTE = "'" as const;
export const AT = "@" as const;
export const MINUS = "-" as const;
export const SOLIDUS = "/" as const;
export const SPACE = " " as const;
export const GREATER_THAN = ">" as const;
export const PLUS = "+" as const;
export const TILDE = "~" as const;
export const ASTERISK = "*" as const;
export const UNDERSCORE = "_" as const;
export const AMPERSAND = "&" as const;
export const COMMA = "," as const;
export const EXCLAMATION = "!" as const;
export const LINE_FEED = "\n" as const;
export const CARRIAGE_RETURN = "\r" as const;
export const HORIZONTAL_TAB = "\t" as const;
export const NULL_CHARACTER = "\0" as const;
export const START_OF_HEADING = "\x01" as const;
export const REVERSE_SOLIDUS = "\\" as const;
export const FORM_FEED = "\f" as const;
